import React from "react";
import { colors, radius, spacing, elevation, zIndex, transitions } from "../../utils/designSystem";

export function UnlockToast({ open, onOpen, onClose }) {

  React.useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  React.useEffect(() => {
    if (!open) return;
    const handleKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  if (!open) return null;

function TypewriterLetter({ text, speed = 30 }) {
  const [chars, setChars] = React.useState(0);
  const rafRef = React.useRef(null);

  React.useEffect(() => {
    if (chars >= text.length) return;
    let last = performance.now();
    const step = (now) => {
      const prev = text[Math.max(0, chars - 1)] || "";
      const delay = /[.!?,]/.test(prev) ? speed * 6 : speed;
      if (now - last >= delay) {
        setChars((c) => Math.min(c + 1, text.length));
        last = now;
      }
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [chars, text, speed]);

  return (
    <pre
      className="whitespace-pre-wrap text-[1.05rem] text-slate-900"
      style={{ fontFamily: "'Special Elite','Courier New',monospace", lineHeight: 1.6 }}
      dangerouslySetInnerHTML={{ __html: text.slice(0, chars) + '<span class="opacity-60">▌</span>' }}
    />
  );
}

  const letter = `Dear Explorer,

Congratulations! You’ve uncovered the final clue: <strong>SEARCH THE BOX</strong>

Did you notice? The box 📦 has been hiding in plain sight all along, waiting at the top right of your screen. Tap it to claim your prize.

Thank you for giving me the chance to show you San Juan. I hope it brought the town to life in a new way, sparked your sense of wonder, and left you with memories to treasure.

— Dr. Arturo Rivera`;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 flex items-center justify-center backdrop-blur-sm"
      style={{
        zIndex: zIndex.modal + 10,
        background: 'rgba(0, 0, 0, 0.7)',
        padding: spacing[6],
      }}
    >
      <div
        className="relative w-full max-w-xl ring-1 ring-black/10"
        style={{
          background: "linear-gradient(180deg,#fffdf6 0%,#f8f1dd 100%)",
          border: `1px solid ${colors.neutral[200]}40`,
          borderRadius: radius.xl,
          boxShadow: elevation['2xl'],
          fontFamily: "'Special Elite','Courier New',monospace",
        }}
      >

        <div className="p-6 sm:p-7">
          <TypewriterLetter text={letter} speed={26} />

          <div style={{ marginTop: spacing[8], display: 'flex', flexDirection: 'column-reverse', gap: spacing[2] }} className="sm:flex-row sm:justify-end">
            <button
              onClick={onClose}
              style={{
                borderRadius: radius.full,
                padding: `${spacing[2]} ${spacing[4]}`,
                fontSize: '0.875rem',
                fontWeight: '600',
                border: `1px solid ${colors.neutral[300]}`,
                background: colors.neutral.white,
                color: colors.neutral[700],
                cursor: 'pointer',
                transition: transitions.default,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = colors.neutral[50];
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = colors.neutral.white;
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
